
import { useEffect, useMemo, useState } from 'react';
import { getBookWeb3SBNInfo } from '@/data';
import { useSelector } from 'react-redux';
import { ethers } from "ethers";
import {
    abiAddress,
    SBNAddress,
    hashSBN,
} from '@/abi/address';
import initWeb3 from './initWeb3';
const useRecord = ({ bookId }) => {
    const { address } = useSelector(state => state.home)
    const [record, setRecord] = useState([]);

    useEffect(() => {
        if (bookId) {
            initWeb3((bookId) => {
                fetchRecords(bookId)
            })(bookId)
        }
    }, [bookId]);
    const refreshRecord = ()=>fetchRecords(bookId)
    const getRecord = async ({sbn,SBNhash}) => {
        try {
           
            let result = await window.SBNContract.methods.getRecord(SBNhash)
                .call()

            setRecord({sbn,SBNhash,...result});
            
        } catch (error) {
                console.log('getRecord error:',error)
        }
    }
    const getBookWeb3SBN = async (bookId) => {
        const { data: { web3_sbn = '' } } = await getBookWeb3SBNInfo({ book_id: +bookId }).catch(err => {
            return { data: { web3_sbn: '' } };
        });
        return web3_sbn

    }
    const fetchRecords = async (bookId) => {
        try {
            const sbn = await getBookWeb3SBN(bookId)
            if (sbn) {
                const SBNhash = hashSBN(sbn)
                getRecord({sbn,SBNhash});
            }

        } catch (error) {
            console.error('Error fetching records:', error);
        }
    };
    const hasRecord = useMemo(()=>{
        console.log('record:::::',record)
        return !!record.length||!!Object.keys(record).length
    },[record])
    const mintedDisabled = useMemo(()=>{
        return !hasRecord || ((record['totalSupply'] - record['mintedCount']) <= 0)
    })
    return { record ,hasRecord,mintedDisabled,refreshRecord};
}
export default useRecord;